import React from 'react';
import { Box } from '@drivekyte/web-components';
import usePartnerReferral from '@/hooks/use-partner-referral';
import usePush from '@/hooks/use-push';
import useSearch from '@/hooks/use-search';
import { QueryBookingCart } from '@/types/booking-cart';
import When from './components/when';
import Where from './components/where';
import { SearchBoxCompactProps } from './types';

const SearchBoxCompact = ({ children, onChange }: SearchBoxCompactProps) => {
  const push = usePush();
  const { hasToRefineAddress } = usePartnerReferral();
  const {
    bookingCart,
    onChange: onChangeSearch,
    onChangeAddressToggle,
  } = useSearch();

  const {
    startPlace,
    startAddress,
    endPlace,
    endAddress,
    startDate,
    endDate,
    isSameDeliveryReturnLocations,
    serviceAreaUUID,
    endServiceAreaUUID,
  } = bookingCart;

  const startHandoverAddress = startPlace || startAddress;
  const endHandoverAddress = endPlace || endAddress;

  const handleChangeAddress = (nextAddressQuery: Partial<QueryBookingCart>) => {
    push({ ...nextAddressQuery, refined_address: true });
    if (onChange) onChange();
  };

  const handleChangeDates = (
    nextEndDate: string,
    nextStartDate: string,
    nextEndTimeZone?: string,
    nextStartTimeZone?: string,
  ) => {
    onChangeSearch({
      end_date: nextEndDate,
      end_timezone: nextEndTimeZone,
      start_date: nextStartDate,
      start_timezone: nextStartTimeZone,
    });
    if (onChange) onChange();
  };

  return (
    <Box display="flex" flexDirection="column">
      <Where
        isSameDeliveryReturnLocations={isSameDeliveryReturnLocations}
        onChangeAddress={handleChangeAddress}
        onChangeToggler={onChangeAddressToggle}
        startAddress={hasToRefineAddress ? undefined : startHandoverAddress}
        endAddress={hasToRefineAddress ? undefined : endHandoverAddress}
      />
      <When
        startDate={startDate}
        startAddress={startAddress}
        endDate={endDate}
        endAddress={endAddress}
        serviceAreaUUID={serviceAreaUUID}
        endServiceAreaUUID={endServiceAreaUUID}
        onChangeDates={handleChangeDates}
      />
      {children}
    </Box>
  );
};

export default SearchBoxCompact;
